import React, { FunctionComponent, ReactNode } from 'react';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';

import inputFieldStyles from './InputFieldStyles';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useIntl } from 'react-intl';

export interface IInputProps {
  type: string;
  prefix: ReactNode | null;
  name: string;
  value: any;
  variant?: 'outlined' | 'filled' | 'standard';
  required: boolean;
  validation?: any;
  color?: 'primary' | 'secondary';
  placeholder?: string;
  isDisabled?: boolean;
  onChange?: (e: any) => void;
  className?: string;
  isDealerSearchError: boolean;
  onDealerSearchError: (hasError: boolean) => void;
}

export const InputField: FunctionComponent<IInputProps> = ({
  placeholder,
  prefix,
  validation,
  value,
  onChange,
  className,
  isDealerSearchError,
  onDealerSearchError,
  ...props
}) => {
  const styles = inputFieldStyles();
  const { errors, touched } = validation;

  const helperTextMapper: () => string = () => {
    if (touched?.postcode && errors?.postcode) {
      return errors?.postcode;
    }

    if (isDealerSearchError) {
      return useIntl().formatMessage({ id: 'spc.dealer.form.validation.noDealer' });
    }

    return '';
  };

  return (
    <Box className={styles.fieldWrapper}>
      <TextField
        {...props}
        variant={'outlined'}
        className={[styles.root, styles.input, className].join(' ')}
        placeholder={placeholder}
        error={!!errors.postcode || isDealerSearchError}
        value={value}
        helperText={helperTextMapper()}
        onChange={e => {
          onDealerSearchError(false);
          return onChange(e);
        }}
        InputProps={{
          startAdornment: <InputAdornment position="start">{prefix}</InputAdornment>,
          classes: {
            root: styles.root,
            focused: styles.focused,
            error: styles.inputError,
            adornedStart: styles.inputAdornment,
            notchedOutline: styles.notchedOutline,
          },
        }}
        FormHelperTextProps={{
          classes: {
            error: styles.helperTextError,
          },
        }}
      />
    </Box>
  );
};

export default InputField;
